import { render, staticRenderFns } from "./gpsrView.vue?vue&type=template&id=f2b24fa4&scoped=true&"
import script from "./gpsrView.vue?vue&type=script&lang=js&"
export * from "./gpsrView.vue?vue&type=script&lang=js&"
import style0 from "./gpsrView.vue?vue&type=style&index=0&id=f2b24fa4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b24fa4",
  null
  
)

export default component.exports